import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "cols", "id", "spacing"],
    _excluded2 = ["actions", "actionThumbnails", "children", "chips", "className", "hasBorder", "id", "isDisabled", "isExternal", "media", "metadata", "mode", "onClick", "padding", "size", "status", "thumbnail", "title", "url", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, createContext } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './Card.styles';
import Actions from './components/Actions';
import Chips from './components/Chips';
import Description from './components/Description';
import Media from './components/Media';
import Metadata from './components/Metadata';
import Status from './components/Status';
import Title from './components/Title';
import Thumbnail from './components/Thumbnail';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CardContext = createContext();
var CardGroup = forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      customClassName = _ref.className,
      _ref$cols = _ref.cols,
      cols = _ref$cols === void 0 ? 3 : _ref$cols,
      id = _ref.id,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 16 : _ref$spacing,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-card-group"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(Styled.CardGroup, _objectSpread(_objectSpread({
    ref: ref,
    id: id,
    className: className,
    cols: cols,
    spacing: spacing
  }, rest), {}, {
    children: children
  }));
});
var Card = forwardRef(function (_ref2, ref) {
  var _cx2;

  var actions = _ref2.actions,
      actionThumbnails = _ref2.actionThumbnails,
      children = _ref2.children,
      chips = _ref2.chips,
      customClassName = _ref2.className,
      _ref2$hasBorder = _ref2.hasBorder,
      hasBorder = _ref2$hasBorder === void 0 ? true : _ref2$hasBorder,
      id = _ref2.id,
      isDisabled = _ref2.isDisabled,
      isExternal = _ref2.isExternal,
      media = _ref2.media,
      metadata = _ref2.metadata,
      _ref2$mode = _ref2.mode,
      mode = _ref2$mode === void 0 ? 'light' : _ref2$mode,
      onClick = _ref2.onClick,
      padding = _ref2.padding,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'medium' : _ref2$size,
      status = _ref2.status,
      thumbnail = _ref2.thumbnail,
      title = _ref2.title,
      url = _ref2.url,
      variant = _ref2.variant,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var className = cx((_cx2 = {}, _defineProperty(_cx2, "".concat(prefix, "-card"), true), _defineProperty(_cx2, "".concat(prefix, "-card--").concat(variant), variant), _defineProperty(_cx2, customClassName, !!customClassName), _cx2));

  var renderCardContent = function renderCardContent() {
    return _jsxs(_Fragment, {
      children: [status && _jsx(Status, {
        data: status,
        padding: padding
      }), thumbnail && _jsx(Thumbnail, {
        data: thumbnail
      }), media && _jsx(Media, {
        data: media
      }), title && _jsx(Title, {
        data: title
      }), (metadata === null || metadata === void 0 ? void 0 : metadata.primary) && _jsx(Metadata, {
        data: metadata.primary
      }), children, chips && _jsx(Chips, {
        data: chips
      }), (metadata === null || metadata === void 0 ? void 0 : metadata.secondary) && _jsx(Metadata, {
        data: metadata.secondary
      }), (actions || actionThumbnails || variant === 'action') && _jsx(Actions, {
        actions: actions,
        actionThumbnails: actionThumbnails
      })]
    });
  };

  var renderLink = function renderLink() {
    var _actions$, _actions$2, _actions$3;

    var externalProps = actions && (_actions$ = actions[0]) !== null && _actions$ !== void 0 && _actions$.isExternal || isExternal ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : null;
    var disabled = actions && ((_actions$2 = actions[0]) === null || _actions$2 === void 0 ? void 0 : _actions$2.isDisabled) || isDisabled;
    var href = actions && ((_actions$3 = actions[0]) === null || _actions$3 === void 0 ? void 0 : _actions$3.url) || url;

    var onClickHandler = function onClickHandler() {
      var _actions$4;

      onClick && onClick();

      if (actions && (_actions$4 = actions[0]) !== null && _actions$4 !== void 0 && _actions$4.onClick) {
        actions[0].onClick();
      }
    };

    return _jsx(_Fragment, {
      children: _jsx(Styled.CardAction, _objectSpread(_objectSpread({
        "aria-disabled": disabled,
        href: href,
        isDisabled: disabled,
        onClick: function onClick() {
          return onClickHandler();
        },
        variant: variant
      }, externalProps), {}, {
        children: renderCardContent()
      }))
    });
  };

  var isLinkCard = variant === 'action' || variant === 'connection' || variant === 'media' || onClick || url;
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(CardContext.Provider, {
      value: {
        isDisabled: isDisabled,
        isLinkCard: isLinkCard,
        variant: variant
      },
      children: _jsx(Styled.Card, _objectSpread(_objectSpread({
        ref: ref,
        id: id,
        className: className,
        isDisabled: isDisabled,
        isLinkCard: isLinkCard,
        hasBorder: hasBorder,
        padding: padding,
        variant: variant
      }, rest), {}, {
        children: isLinkCard ? renderLink() : renderCardContent()
      }))
    })
  });
});
Card.Actions = Actions;
Card.Group = CardGroup;
Card.Chips = Chips;
Card.Description = Description;
Card.Media = Media;
Card.Metadata = Metadata;
Card.Status = Status;
Card.Title = Title;
Card.Thumbnail = Thumbnail;
export default Card;